/** @jsxImportSource @emotion/react */
import { css } from '@emotion/react';

import { StylingContextState } from 'context/Styling';

export const mfaLoginStyles = ({ colors }: StylingContextState) => ({
  container: css`
    display: flex;
    flex-direction: column;
    max-width: 400px;
    margin: 0 auto;
    width: 100%;
  `,
  title: css`
    margin-bottom: 0.5rem !important;
  `,
  description: css`
    color: ${colors.text.secondary};
    margin: 0 0 1.5rem 0 !important;
  `,
  form: css`
    display: flex;
    flex-direction: column;
    width: 100%;
  `,
  codeInputContainer: css`
    display: flex;
    flex-direction: column;
    width: 100%;

    > div:first-of-type {
      margin-bottom: 0.5rem;
    }

    > button {
      margin-top: 0.5rem !important;
      margin-bottom: 0 !important;
    }

    input {
      text-align: center;
      letter-spacing: 0.25em;
      font-size: 1.25rem;
    }
  `,
  recoveryCodeInput: css`
    input {
      text-align: left;
      letter-spacing: normal;
      font-size: 1rem;
    }
  `,
  actionsContainer: css`
    display: flex;
    flex-direction: column;
    align-items: center;
    margin-top: 1rem;

    .alternate-action {
      margin: 8px 0 0 !important;
    }
  `,
});
